import { Redirect, Route } from 'react-router-dom';
import PrivateRouteLogic from './privateRoute.logic';
import GeneralContext from '../../context/GeneralContext';
import { useContext, useEffect } from 'react';

export function PrivateRoute({ component: Component, allowedRoles, ...rest }) {
  const { state, isValidRole, translator } = PrivateRouteLogic({
    allowedRoles,
  });
  const { setGeneralValues } = useContext(GeneralContext);

  const { path } = rest;

  useEffect(() => {
    if (path === '/interactiveMap') {
      console.log('Setting pathAfterLogin for interactiveMap');
      setGeneralValues((old_values) => ({
        ...old_values,
        pathAfterLogin: '/interactiveMap',
      }));
    }
  }, [path, setGeneralValues]);

  return (
    <Route
      {...rest}
      render={(props) => {
        switch (state) {
          case 'loading':
            return <div>{translator('privateRoute.loading')}</div>;
          case 'logged':
            if (allowedRoles && !isValidRole) {
              return <Redirect to="/dashboard" />;
            }
            return <Component {...props} />;
          case 'redirect':
            return (
              <Redirect
                to={{
                  pathname: '/login',
                }}
              />
            );
          default:
            return <div>{translator('privateRoute.loading')}</div>;
        }
      }}
    />
  );
}
